export const getVariantNameFromId = (variantId: string) => {
  const variantIdParts = variantId.split('-');

  //variant id will always have 2 hyphen (-) separating make id, model id and variant
  //but in some cases the value passed to this function maybe `any_variant` or something similar, representing a null value
  return variantIdParts.length === 3 ? variantIdParts[2] : variantId;
};
